import React, { FC } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import PromoOptionsContent from './PromoOptionsContent';
import type { PromoOptionsListProps } from './types';

import styles from './index.module.scss';

const PromoOptionsList: FC<PromoOptionsListProps> = ({
  hasNextPage,
  isInitialLoading,
  isNextPageLoading,
  isBulkSelectionActionPending,
  items,
  queryError,
  queryKey,
  onLoadMore,
  onPromoPlaybackToggle,
  onPromoSelectionChange,
  onRetry,
}) => (
  <div
    className={styles.list}
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_LIST}
    aria-busy={isInitialLoading || isNextPageLoading}>
    <PromoOptionsContent
      hasNextPage={hasNextPage}
      isInitialLoading={isInitialLoading}
      isBulkSelectionActionPending={isBulkSelectionActionPending}
      items={items}
      queryError={queryError}
      queryKey={queryKey}
      onLoadMore={onLoadMore}
      onPromoPlaybackToggle={onPromoPlaybackToggle}
      onPromoSelectionChange={onPromoSelectionChange}
      onRetry={onRetry}
    />
  </div>
);

export default PromoOptionsList;
